import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { InsuranceCompany } from '@uplift/api';

export const usePreferredInsuranceStyles = makeStyles()(theme => ({
  accepts: {
    alignSelf: 'flex-start',
    borderBottom: `2px solid ${theme.palette.success.main}`,
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: '14px',
    textTransform: 'uppercase',
    [theme.breakpoints.up('sm')]: {
      fontSize: '14px',
    }
  },
  alignment: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(.5),
    height: '21px',
  },
  check: {
    color: theme.palette.success.main,
    fontSize: '1rem',
    fontWeight: 450,
    lineHeight: '150%',
    [theme.breakpoints.up('sm')]: {
      fontSize: '20px',
    }
  },
  insurance: {
    alignSelf: 'flex-start',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: '14px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '14px',
    }
  },
  root: {
    alignItems: 'center',
    display: 'flex',
    gap: '4px',
    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
    }
  },
  justify: {
    justifyContent: 'flex-end',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'unset',
    }
  }
}));

type PreferredInsuranceMatchProps = {
  insuranceCompany?: InsuranceCompany;
  name?: string;
  justify?: boolean;
};

export const PreferredInsuranceMatch: React.VFC<PreferredInsuranceMatchProps> = ({ insuranceCompany, name, justify = true }) => {
  const { classes, cx } = usePreferredInsuranceStyles();

  if (!insuranceCompany?.shortName && !name) {
    return <Box />;
  }

  return (
    <Box className={cx(classes.root, justify && classes.justify)}>
      <Box className={classes.alignment}>
        <Typography className={classes.check}>
          ✓
        </Typography>
        <Typography className={classes.accepts}>
          ACCEPTS
        </Typography>
      </Box>
      <Box className={classes.insurance}>
        {name ?? insuranceCompany?.shortName}
      </Box>
    </Box>
  );
};
